import { Color } from 'root-constants'

export const setZenDeskWidget = (
  handleZendeskToggle: () => void,
  setIsZendeskLoading: (value) => void,
): void => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.id = 'ze-snippet'
  script.src =
    'https://static.zdassets.com/ekr/snippet.js?key=e58ac075-c3cd-4b0b-be59-1568d8976328'
  script.onload = () => {
    handleZendeskToggle()
    window.zE('webWidget:on', 'close', () => {
      window.zE('webWidget', 'hide')
      setIsZendeskLoading(false)
    })
  }

  document.head.appendChild(script)

  window.zESettings = {
    webWidget: {
      color: { theme: Color.DARK },
      position: { horizontal: 'right', vertical: 'top' },
      contactForm: {
        subject: true,
        fields: [
          {
            id: 'subject',
            prefill: { '*': 'Mood Balance' },
          },
        ],
      },
    },
  }
}
